import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, TextField, Typography } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import Box from '@mui/material/Box';
import {
  saveProfesionesAction,
  setActivoProfesionesAction,
} from '../ProfesionesAction';
import { validMessage } from '../../../../constants/ValidsFormConst';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import { useNotification } from '../../../../helpers/Notification';

const FormProfesiones = ({ isDelete = false }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const profesionesStore = Redux.useSelector((state) => state.profesiones);

  const activo = isDelete ? null : profesionesStore.activo;

  const initData = {
    nombre: '',
    link: '',
    desc: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;

    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idEstatus: activo.estatus?.id ?? 2,
        }),
      300,
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (await _validDataForm()) {
      setLoadingSave(true);
      const res = await saveProfesionesAction(
        { dispatch, notify },
        activo?.id,
        data,
        profesionesStore.params,
      );
      if (res) clearData();
      setLoadingSave(false);
    }
  };

  function clearData() {
    setActivoProfesionesAction(dispatch, null);
    setData(initData);
  }

  return (
    <Box component="form" sx={{ m: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          <Typography variant="h6">
            {activo ? 'Editar perfil' : 'Crear'}
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(
                CONST.nombre.name,
                e.target.value.toUpperCase(),
              )
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.link.name}
            label={CONST.link.label}
            value={data.link}
            onChange={(e) =>
              _handleSetDataField(CONST.link.name, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            mr={2}
            saveIcon
          />
          {activo && (
            <BotonComponent
              click={clearData}
              text="CANCELAR"
              disabled={loadingSave}
              black
              closeIcon
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormProfesiones;
